import { gql } from '@apollo/client'

export const GET_VALID_IMAGE_FORMATS = gql`
  query ValidImageFormat {
    validImageFormat
  }
`
